import { isCloud } from '@blk/aw-env-detection';
import { conditionalParam as baseConditionalParam, ParamExclusionRule } from '../../utils/ApiUtils';
import { awBffServerSettings } from './Base';

export const isAGraphEnabled = () => {
  // Temporarily only using AGraph APIs externally until the legacy internal ones are fixed by AGraph team
  if (isCloud()) {
    return awBffServerSettings.getAGraphConfig?.()?.['aw-bff'] ?? false;
  }
  return false;
};

/**
 * Default exclusion rules for AWBffServer AGraph/Cloud APIs that reject unknown query params
 * Each rule can specify different params to exclude for different URL prefixes
 */
const AW_BFF_PARAM_EXCLUSION_RULES: ParamExclusionRule[] = [
  {
    urlPrefix: ['/packages/list', '/user', '/version'],
    excludedParams: ['pkg', 'configurationDirectory'],
  },
  {
    urlPrefix: ['/dates', 'pdf-export/generate-pdf', 'view-as/'],
    excludedParams: ['configurationDirectory'],
  },
  {
    urlPrefix: ['pdf-export/templates', '/compl-rule'],
    excludedParams: ['pkg'],
  },
  {
    urlPrefix: ['/dates', '/packages/list', '/user', 'pdf-export', '/version'],
    excludedParams: ['viewAs'],
  },
];

/**
 * Returns the parameter value or undefined if it should be excluded for AWBffServer endpoints
 * @param url - The API endpoint URL
 * @param paramName - The parameter name
 * @param value - The parameter value
 * @returns The value if not excluded, undefined otherwise
 */
export function conditionalParam<T>(url: string | undefined, paramName: string, value: T): T | undefined {
  return baseConditionalParam(url, paramName, value, AW_BFF_PARAM_EXCLUSION_RULES);
}
